import { ChevronRight, Home } from "lucide-react";
import { Link } from "react-router-dom";

type BreadcrumbItem = {
  label: string;
  href?: string;
};

type BreadcrumbsProps = {
  items: BreadcrumbItem[];
  homeHref?: string;
};

export function Breadcrumbs({ items, homeHref }: BreadcrumbsProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-4 flex items-center gap-1.5 overflow-x-auto text-sm text-muted [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      {homeHref && (
        <Link to={homeHref} className="text-muted transition-colors hover:text-primary">
          <Home size={16} strokeWidth={1.75} />
        </Link>
      )}
      {items.map((item, index) => (
        <span key={index} className="flex shrink-0 items-center gap-1.5">
          {(index > 0 || homeHref) && <ChevronRight size={14} />}
          {item.href ? (
            <Link to={item.href} className="hover:text-primary">
              {item.label}
            </Link>
          ) : (
            <span className="font-semibold text-foreground">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
